export enum RbacApiPermission {
    actionPostEntityResolve = 'action:postEntityResolve',
    actionPostGlobalResolve = 'action:postGlobalResolve',
    actionsGet = 'actions:get',
    chatbotPostQuestion = 'chatbot:postQuestion',
    contractExtractionGetData = 'contractExtraction:getData',
    contractExtractionGetDocument = 'contractExtraction:getDocument',
    contractExtractionPost = 'contractExtraction:post',
    configGetActivityHistory = 'config:getActivityHistory',
    configGetApiKey = 'config:getApiKey',
    configGetBrandingSettings = 'config:getBrandingSettings',
    configGetCustomProperties = 'config:getCustomProperties',
    configPostCustomProperty = 'config:postCustomProperty',
    configPatchCustomProperty = 'config:patchCustomProperty',
    configDeleteCustomProperty = 'config:deleteCustomProperty',
    configGetFulfillmentSettings = 'config:getFulfillmentSettings',
    configGetNotificationPreferences = 'config:getNotificationPreferences',
    configGetRpSettings = 'config:getRpSettings',
    configGetWebhooks = 'config:getWebhooks',
    configPatchInsuranceSettings = 'config:patchInsuranceSettings',
    configPatchWebhook = 'config:patchWebhook',
    configPostTestNotificationEmail = 'config:postTestNotificationEmail',
    configPostWebhook = 'config:postWebhook',
    configPutBrandingSettings = 'config:putBrandingSettings',
    configPutCadenceSettings = 'config:putCadenceSettings',
    configPutDefaultBrandingSettings = 'config:putDefaultBrandingSettings',
    configPutEmailSettings = 'config:putEmailSettings',
    configPutFulfillmentSettings = 'config:putFulfillmentSettings',
    configPutRpSettings = 'config:putRpSettings',
    configPutSupportContactInfo = 'config:putSupportContactInfo',
    configPutTprmRequestsSettings = 'config:putTprmRequestsSettings',
    entitiesGet = 'entities:get',
    entityCreate = 'entity:create',
    entityDeleteException = 'entity:deleteException',
    entityDeleteWebhook = 'entity:deleteWebhook',
    entityGet = 'entity:get',
    entityGetCollaterals = 'entity:getCollaterals',
    entityGetCollateralsMappings = 'entity:getCollateralsMappings',
    entityGetDetails = 'entity:getDetails',
    entityGetExport = 'entity:getExport',
    entityGetRequirementDocument = 'entity:getRequirementDocument',
    entityGetRiskProfiles = 'entity:getRiskProfiles',
    entityGetSubmissionLink = 'entity:getSubmissionLink',
    entityGetVerifications = 'entity:getVerifications',
    entityPatchCollateralsMappings = 'entity:patchCollateralsMappings',
    entityPostDocument = 'entity:postDocument',
    entityPostExceptions = 'entity:postExceptions',
    entityPut = 'entity:put',
    riskCriteriaPatch = 'riskCriteria:patch',
    riskCriteriaPost = 'riskCriteria:post',
    riskProfileDelete = 'riskProfile:delete',
    riskProfileGet = 'riskProfile:get',
    riskProfilePost = 'riskProfile:post',
    riskProfilePut = 'riskProfile:put',
    userDelete = 'user:delete',
    userPost = 'user:post',
    userPostResendInvite = 'user:postResendInvite',
    userPut = 'user:put',
    usersGet = 'users:get',
    verificationsPostOnDemand = 'verifications:postOnDemand',
    verificationsPostForceSubmission = 'verifications:postForceSubmission',
    webhooksPatch = 'webhooks:patch',
    documentDataReviewGet = 'documentDataReview:get',
    documentDataReviewGetDocuments = 'documentDataReview:getDocuments',
    entityGetEntityNote = 'entity:getNote',
    entityCreateEntityNote = 'entity:createNote',
}
